import { render, staticRenderFns } from "./findPersonDetail.vue?vue&type=template&id=97a2b53a&scoped=true&"
import script from "./findPersonDetail.vue?vue&type=script&lang=js&"
export * from "./findPersonDetail.vue?vue&type=script&lang=js&"
import style0 from "./findPersonDetail.vue?vue&type=style&index=0&id=97a2b53a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a2b53a",
  null
  
)

export default component.exports